import { EMPTY_STRING } from '../../../constants/common'
import { getHtmlEmailLink, getHtmlTelLink } from '../../../utils/link'
import {
  BIRDVIEW_META_SEPARATOR,
  BirdviewHomeContactType,
} from '../DashboardBirdview.constants'

import {
  BIRDVIEW_HOME_CONTACT_TOOLTIP_KEY,
  BIRDVIEW_HOME_PHONE_SEPARATOR_PATTERN,
} from './BirdviewHomeRow.constants'

function checkIsBirdviewHomePhoneContact({ type }) {
  return type === BirdviewHomeContactType.Phone
}

export function checkIsBirdviewHomeContact({ type }) {
  return Boolean(type)
}

export function getBirdviewHomeRowLabel({ labelKey, note }, t) {
  return [t(labelKey), note].filter(Boolean).join(BIRDVIEW_META_SEPARATOR)
}

export function getBirdviewHomeContactTooltipKey({ type }) {
  return BIRDVIEW_HOME_CONTACT_TOOLTIP_KEY[type]
}

// A phone link dials only when the number carries no spaces.
export function getBirdviewHomeContactHref(item) {
  if (checkIsBirdviewHomePhoneContact(item)) {
    return getHtmlTelLink(
      item.value.replace(BIRDVIEW_HOME_PHONE_SEPARATOR_PATTERN, EMPTY_STRING)
    )
  }

  return getHtmlEmailLink(item.value)
}
